// Native rows are supplied only by the direct macOS data adapter.
export default function NativeCollectionChatItem() { return null; }
